import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { isRequired } from '@cbgms/base/utils/validations'
import { Checkbox, TextField } from '@carsys/form'

export const PaymentMethodsField = () => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <TextField required validate={isRequired} label={t('entities.paymentmethod.code')} name='Code' inputProps={{ maxLength: 50 }} />
      </Grid>
      <Grid item xs={6}>
        <TextField required validate={isRequired} label={t('entities.paymentmethod.name')} name='Name' inputProps={{ maxLength: 50 }} />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label={t('entities.paymentmethod.description')}
          name='Description'
          inputProps={{ maxLength: 250 }}
        />
      </Grid>
      <Grid item container direction='column' xs={6}>
        <Checkbox label={t('entities.paymentmethod.isenabled')} name='IsEnabled' />
        <Checkbox label={t('entities.paymentmethod.preventaccountancyexport')} name='PreventAccountancyExport' />
      </Grid>
    </Grid>
  )
}
